import { render, staticRenderFns } from "./DatavizInfos.vue?vue&type=template&id=33d753f8&scoped=true"
import script from "./DatavizInfos.vue?vue&type=script&lang=ts"
export * from "./DatavizInfos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d753f8",
  null
  
)

export default component.exports